import React from "react";
import { EditorialImage } from "./EditorialImage";
import { IngredientGroupCard } from "../components/post/IngredientGroupCard";
import WineTastingGridView from "../components/wine/WineTastingGridView";

function HtmlBlock({ html }) {
  if (!html || !String(html).trim()) return null;
  return <div dangerouslySetInnerHTML={{ __html: html }} />;
}

/**
 * Renders analyzed content blocks inside a .post-content shell.
 */
export function EditorialContent({ plan, className = "", igroupDefaultExpanded = false }) {
  const blocks = plan?.blocks || [];
  return (
    <main className={`post-content ${className}`.trim()}>
      {blocks.map((block, index) => {
        if (block.type === "html") {
          return <HtmlBlock key={`html-${index}`} html={block.html} />;
        }
        if (block.type === "image") {
          return (
            <EditorialImage
              key={`img-${block.mediaUuid}-${index}`}
              src={block.src}
              description={block.description}
              role={block.role || "inline"}
            />
          );
        }
        if (block.type === "igroup") {
          return (
            <IngredientGroupCard
              key={`igroup-${block.groupUuid}-${index}`}
              group={block.group}
              defaultExpanded={igroupDefaultExpanded}
            />
          );
        }
        if (block.type === "tasting") {
          const payload = block.tasting?.payload || {};
          return (
            <WineTastingGridView
              key={`tasting-${block.tastingUuid}-${index}`}
              answers={payload.answers || {}}
              wine={payload.wine || null}
              mode="all"
              title={block.tasting?.title || "Vinsmagning"}
              comparisons={payload.comparisons || null}
              expected={payload.expected || null}
            />
          );
        }
        return null;
      })}
    </main>
  );
}

/** @deprecated use IngredientGroupCard */
export function IngredientGroupBlock({ group }) {
  return <IngredientGroupCard group={group} defaultExpanded />;
}

export default EditorialContent;
